// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let AcceptedMessage = function (fieldSet)
{
    this.Code = Message.CODE_PFIX_ACCEPTED_MESSAGE
    PFixMessage.call(this, fieldSet)
}

AcceptedMessage.prototype = Object.create(PFixMessage.prototype)

AcceptedMessage.prototype.getOrderId = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ORDER_ID)
}

AcceptedMessage.prototype.setOrderId = function (orderId)
{
    this.setFieldValue(FieldsFactory.FIELD_ORDER_ID, orderId)
}

AcceptedMessage.prototype.getPositionId = function ()
{
    // FIELD_POSITION_ID может и не быть
    return this.getFieldValue(FieldsFactory.FIELD_POSITION_ID) || 0
}

AcceptedMessage.prototype.setPositionId = function (positionId)
{
    this.setFieldValue(FieldsFactory.FIELD_POSITION_ID, positionId)
}
